import NativeUrlConnector from '@stilingue/st-native-url-connector';
import StURLController from '@stilingue/st-url-controller';
import StRequests, { authentication } from '@stilingue/st-requests';

const authStore = authentication({ tokenName: 'stilingue-session-id' });

function findSessionIdOnCookie() {
  return authStore.getSessionId();
}

function findSessionIdOnURL() {
  const nativeUrlConnector = NativeUrlConnector(window);
  const urlController = StURLController(nativeUrlConnector);

  return urlController.getParamsByName('ssid');
}

function removeSessionIdOnURL() {
  const nativeUrlConnector = NativeUrlConnector(window);
  const urlController = StURLController(nativeUrlConnector);

  return urlController.removeParamInUrl('ssid');
}

function findAndHandleSessionId() {
  const sessionIdOnCookie = findSessionIdOnCookie();
  if (sessionIdOnCookie) {
    removeSessionIdOnURL();
    return sessionIdOnCookie;
  }

  const sessionIdOnURL = findSessionIdOnURL();
  if (sessionIdOnURL) {
    authStore.setSessionId(sessionIdOnURL, { expires: 365 });
    removeSessionIdOnURL();
    return sessionIdOnURL;
  }

  return null;
}

function getDomain() {
  const { host } = window.location;
  const productionDomain = '.stilingue.com.br';
  return host.match(productionDomain) ? productionDomain : '';
}

export function checkForAuthentication() {
  return findAndHandleSessionId();
}

export function setCookie(cookieName, token) {
  const auth = authentication({ tokenName: cookieName });
  return auth.setSessionId(token, { domain: getDomain() });
}

/**
 * Make login for New authentication and old one.
 * PS: usr_id uses "_" because the old way to communicate with backend was with snake_case.
 * @param SSID Stilingue-session-id , token of the new authentication
 * @param usr_id cookie used in old authentication system
 */
export function login({ SSID = '', usr_id = '' } = {}) {
  SSID && setCookie('stilingue-session-id', SSID);
  usr_id && setCookie('usr_id', usr_id);
}

export function removeCookie(cookieName) {
  const auth = authentication({ tokenName: cookieName });
  return auth.removeSessionId({ domain: getDomain() });
}

export function logout() {
  removeCookie('stilingue-session-id');
  removeCookie('usr_id');
}

export function logoutAndSendUserToLoginPage() {
  logout();
  window.location.href = '/login';
}

export function logoutAndSendUserTo403Page() {
  logout();
  window.location.href = '/403';
}

function removeUrlFromData(request) {
  if (['put', 'post'].includes(request.method)) {
    delete request.data.url;
  }
  return request;
}

export function createApi(url, gateway, {
  requester = null,
  authNotFound = logoutAndSendUserToLoginPage,
  error401Handler = logoutAndSendUserToLoginPage,
  timeout = null
} = {}) {
  const api = new StRequests(url, requester);

  api.use({
    baseURL: gateway,
    retry: false,
    timeout,
    interceptors: {
      request: removeUrlFromData
    },
    errorStatusInterceptors: {
      authNotFound,
      401: error401Handler
    },
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    },
  });

  return api;
}
